import { apiClient } from "./ApiClient";

export async function fetchCountryPackages({ skip = 0, limit = 20, currency, popular = false } = {}) {
  try {
    const res = await apiClient.get("/package/country/prices", {
      params: { skip, limit, currency, popular },
    });

    return res.data; // { total, count, items: [...] }
  } catch (error) {
    const err = new Error("Failed to load country packages");
    err.status = error.response?.status;
    err.response = {
      status: error.response?.status,
      data: error.response?.data,
    };
    throw err;
  }
}

export async function fetchRegionPackages({ skip = 0, limit = 40, currency } = {}) {
  try {
    const res = await apiClient.get("/package/region/prices", {
      params: { skip, limit, currency },
    });

    return res.data; // { total, count, items: [...] }
  } catch (error) {
    const err = new Error("Failed to load region packages");
    err.status = error.response?.status;
    err.response = {
      status: error.response?.status,
      data: error.response?.data,
    };
    throw err;
  }
}

export async function fetchPackagesBatch({
  sortBy = "price",
  ascOrder = true,
  limit = 50,
  skip = 0,
  countryId = null,
  regionId = null,
  currency,
} = {}) {
  try {
    const params = {
      sort_by: sortBy,
      asc_order: ascOrder,
      limit,
      skip,
      currency,
    };

    if (countryId) {
      params.country_id = countryId;
    }
    if (regionId) {
      params.region_id = regionId;
    }

    const res = await apiClient.get("/package/batch", { params });

    return res.data;
  } catch (error) {
    const err = new Error("Failed to load packages");
    err.status = error.response?.status;
    err.response = {
      status: error.response?.status,
      data: error.response?.data,
    };
    throw err;
  }
}

export async function fetchCountriesByRegion({
  skip = 0,
  limit = 300,
  regionId,
  popular = false,
} = {}) {
  try {
    const res = await apiClient.get("/package/country/batch", {
      params: { skip, limit, popular, region_id: regionId },
    });

    return res.data; // { total, count, items: [...] }
  } catch (error) {
    const err = new Error("Failed to load region countries");
    err.status = error.response?.status;
    err.response = {
      status: error.response?.status,
      data: error.response?.data,
    };
    throw err;
  }
}

export async function fetchPackageById(packageId, currency) {
  try {
    const res = await apiClient.get(`/package/${packageId}`, {
      params: {
        currency,
      },
    });
    return res.data;
  } catch (error) {
    const err = new Error("Failed to load package");
    err.status = error.response?.status;
    err.response = {
      status: error.response?.status,
      data: error.response?.data,
    };
    throw err;
  }
}

export async function fetchInternalPackage(packageId, currency = "EUR") {
  const { data } = await apiClient.get(`/internal/${packageId}`, {
    params: { currency },
  });
  return data;
}
